import { Modal, Tabs } from 'antd';
import ItemsList from 'containers/TransferOrder/List/BatchList/ItemsList';
import OrdersList from 'containers/TransferOrder/List/BatchList/OrdersList';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ViewBatchGroupButton from '../ViewBatchGroupButton';
import { createTransferOrdersBatch } from '@redux/transferOrdersBatch/actions';
import { useDispatch } from '@redux';
import { useNavigate } from 'react-router-dom';
import { DynamicObjectType } from 'types/commons';
import crudActions from '@redux/crudActions';

interface IConfirmBatchModalProps {
  visible: boolean;
  onCancel: () => void;
  transferOrdersSelected: any[];
}

const ConfirmBatchModal = ({
  visible,
  onCancel,
  transferOrdersSelected,
}: IConfirmBatchModalProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [tabList, setTabList] = React.useState('orders');
  const [loading, setLoading] = React.useState(false);

  const TABS = [
    {
      text: 'Orders',
      value: 'orders',
      components: transferOrdersSelected?.length > 0 && (
        <OrdersList selectedData={transferOrdersSelected} />
      ),
    },
    {
      text: 'Items',
      value: 'items',
      components: transferOrdersSelected?.length > 0 && (
        <ItemsList selectedData={transferOrdersSelected} />
      ),
    },
  ];

  const handleCreate = async (data) => {
    setLoading(true);
    try {
      const res: DynamicObjectType = await dispatch(
        createTransferOrdersBatch({
          data: {
            transferIds: data,
          },
          options: {
            customApiResource: 'transfer-orders-batch/create',
            isShowSuccessNoti: true,
          },
        }),
      );
      if (res?.payload?.data?.success) {
        setLoading(false);
        onCancel();
        navigate(`/transfer-orders?status=SHIPPING`);
        dispatch(
          crudActions.transferConfirmedPick.setSelectedRowKeys([] as any),
        );
      }
    } catch {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={850}
      closeIcon={false}
      closable={false}
      title={t('transferOrders.viewBatch')}
    >
      <div className="grid gap-5">
        <Tabs activeKey={tabList} onChange={(e) => setTabList(e)}>
          {TABS.map((e) => (
            <Tabs.TabPane
              tab={t(e.text)}
              key={e.value}
              tabKey={e.value}
              children={e?.components}
            />
          ))}
        </Tabs>
        <ViewBatchGroupButton
          onCancel={onCancel}
          handleCreate={handleCreate}
          loading={loading}
        />
      </div>
    </Modal>
  );
};

export default ConfirmBatchModal;
